import React from 'react';
import {
  getHeroContent, TopControls, TabContent, getTabLabel, InlineEditableText
} from './ThemeLayoutHelpers';


export default function FreshLayout({ p }) {
  const text = p.storefrontText || {};
  const copy = getHeroContent(p, {
    eyebrow: "Fresh daily arrivals",
    title: "Bright picks for modern living",
    subtitle: "Built for quick discovery with clean filters, smart categories, and smooth browsing for repeat customers.",
  });
  const pages = ["products", "services", "details"];
  const activeProduct = p.activeTab || "products";
  const setActiveProduct = p.setActiveTab;
  const search = p.searchQuery || "";
  const setSearch = p.setSearchQuery;
  const selectedCategory = p.activeTab || "products";
  const setSelectedCategory = p.setActiveTab;
  const cartCount = p.cart?.reduce((sum, item) => sum + (item.cartQuantity || 1), 0) || 0;
  const store = {
    wishlistCount: p.wishlistCount || 0,
    handleWishlist: p.handleGoToWishlist,
    cartCount,
    handleCart: p.handleOpenCart,
  };
  const ProductGrid = () => <TabContent p={p} />;

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_right,#d9ffe7_0%,#f3fff7_42%,#eafff2_100%)] text-[#123829]">
      <div className="mx-auto w-full max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-[#8fd9af] bg-[#f6fffa] p-4 shadow-[0_16px_45px_rgba(20,120,70,0.13)] sm:p-6">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <span className="inline-flex items-center rounded-full bg-[#dbfce7] px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-[#1f7d4f]"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
              <h1 className="mt-3 text-3xl font-semibold tracking-tight text-[#0f3d2b] sm:text-4xl"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
              <p className="mt-2 max-w-2xl text-sm text-[#2c6b4d] sm:text-base"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
            </div>
            <button
              type="button"
              onClick={p.handleBackToLanding}
              className="rounded-full bg-[#1e8c55] px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-[#177445]"
            >
              {text.back || "Back"}
            </button>
          </div>

          <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {[
              { label: "Live SKUs", value: "2,400+" },
              { label: "Repeat Rate", value: "64%" },
              { label: "Fast Dispatch", value: "Same Day" },
              { label: "Store Rating", value: "4.8/5" },
            ].map((item) => (
              <div
                key={item.label}
                className="rounded-2xl border border-[#b8eecf] bg-white/85 px-4 py-3"
              >
                <p className="text-[11px] font-semibold uppercase tracking-[0.13em] text-[#2f8f5d]">
                  {item.label}
                </p>
                <p className="mt-1 text-xl font-semibold text-[#134c33]">{item.value}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-5 rounded-2xl border border-[#ade7c7] bg-white/90 p-3 backdrop-blur">
          <TopControls
            search={search}
            setSearch={setSearch}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            categories={pages}
            store={store}
            showCategoryInSearch={false}
            shellClassName="border-[#bdebcf] bg-[#fbfffd]"
            searchClassName="h-11 border-[#94ddb8] bg-[#f2fff7] text-[#135538] placeholder:text-[#5d9c7b] focus:ring-[#1f8d58]/30"
            selectClassName="h-11 border-[#94ddb8] bg-[#f2fff7] text-[#1c6545] focus:ring-[#1f8d58]/30"
            rightActionsClassName="gap-2"
            iconButtonClassName="border-[#9fdfbe] bg-[#effff6] text-[#177046] hover:bg-[#e3f8ee]"
          />
        </div>

        <div className="mt-5 overflow-x-auto pb-1">
          <div className="flex min-w-max items-center gap-2">
            {pages.map((page) => {
              const active = activeProduct === page;
              return (
                <button
                  key={page}
                  type="button"
                  onClick={() => setActiveProduct(page)}
                  className={`rounded-full px-4 py-2 text-sm font-semibold transition ${
                    active
                      ? "bg-[#1f8f58] text-white shadow-[0_9px_24px_rgba(20,120,70,0.3)]"
                      : "border border-[#a6e1c2] bg-white/90 text-[#216847] hover:bg-[#effff6]"
                  }`}
                >
                  {getTabLabel(p, page)}
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-6 rounded-3xl border border-[#aee4c6] bg-white/92 p-4 shadow-[0_14px_36px_rgba(26,112,70,0.1)] sm:p-5">
          <ProductGrid />
        </div>
      </div>
    </div>
  );
}